import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const ICON_MAP = {
  Groceries: { icon: 'ShoppingCart', color: '#10B981' },
  'Dining Out': { icon: 'UtensilsCrossed', color: '#F59E0B' },
  Entertainment: { icon: 'Tv', color: '#EC4899' },
  Transportation: { icon: 'Car', color: '#7C3AED' },
  Shopping: { icon: 'ShoppingBag', color: '#3B82F6' },
  Income: { icon: 'Banknote', color: '#06B6D4' },
};

export default function RecentTransactions({ transactions, loading }) {
  const [showAll, setShowAll] = useState(false);
  const txList = transactions || [];
  const displayed = showAll ? txList : txList?.slice(0, 5);

  const getIconInfo = (tx) => {
    if (tx?.transaction_type === 'income') return { icon: 'Banknote', color: '#06B6D4' };
    const catName = tx?.spending_categories?.name || '';
    return ICON_MAP?.[catName] || { icon: 'CreditCard', color: '#94A3B8' };
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return `${(d?.getMonth() + 1)?.toString()?.padStart(2, '0')}/${d?.getDate()?.toString()?.padStart(2, '0')}/${d?.getFullYear()}`;
  };

  return (
    <div className="bg-[#0F172A] border border-[rgba(6,182,212,0.1)] rounded-xl p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-heading font-semibold text-base md:text-lg text-[#F8FAFC]">Recent Transactions</h3>
          <p className="text-xs text-[#94A3B8] mt-0.5">Last 7 days</p>
        </div>
        {txList?.length > 5 && (
          <button
            onClick={() => setShowAll(p => !p)}
            className="text-xs text-[#06B6D4] hover:text-[#22D3EE] transition-colors min-h-[32px] px-2"
          >
            {showAll ? 'Show less' : 'View all'}
          </button>
        )}
      </div>
      {loading ? (
        <div className="space-y-2">
          {[1, 2, 3, 4, 5]?.map((i) => (
            <div key={i} className="h-12 bg-[#1E3A5F] rounded-lg animate-pulse" />
          ))}
        </div>
      ) : displayed?.length === 0 ? (
        <div className="text-center py-8">
          <Icon name="Receipt" size={32} color="#475569" />
          <p className="text-sm text-[#475569] mt-2">No transactions yet</p>
        </div>
      ) : (
        <div className="space-y-1">
          {displayed?.map((tx) => {
            const { icon, color } = getIconInfo(tx);
            const amount = parseFloat(tx?.amount) || 0;
            const isIncome = tx?.transaction_type === 'income';
            return (
              <div
                key={tx?.id}
                className="flex items-center gap-3 p-2.5 rounded-lg hover:bg-[rgba(6,182,212,0.04)] transition-all cursor-pointer group"
              >
                <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${color}20` }}>
                  <Icon name={icon} size={16} color={color} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-[#F8FAFC] truncate font-medium">{tx?.merchant}</p>
                  <p className="text-xs text-[#94A3B8]">
                    {tx?.spending_categories?.name || (isIncome ? 'Income' : 'Other')} · {formatDate(tx?.transaction_date)}
                  </p>
                </div>
                <span className={`font-data text-sm font-semibold whitespace-nowrap ${isIncome ? 'text-[#10B981]' : 'text-[#F8FAFC]'}`}>
                  {isIncome ? '+' : '-'}${amount?.toFixed(2)}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}